import { useQuery } from 'react-query';
import { useContext } from 'react';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AppContext } from 'views/App/context';

import type { AccreditationStandard } from '../../../_types/awb';

export async function getStandard(
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  useRUIData = false
): Promise<AccreditationStandard> {
  // Use non-org-specific API when awbRUIData feature is enabled
  const url = useRUIData
    ? `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}`
    : `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
}

export default function useAccreditationStandardById(
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  enabled?: boolean,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const { isFeatureEnabled } = useContext(AppContext);
  const useRUIData = isFeatureEnabled('awbRUIData');

  return useQuery<AccreditationStandard, Error>(
    ['accreditation_standards', orgId, accreditationBodyId, versionId, standardId, useRUIData],
    () => getStandard(orgId, accreditationBodyId, versionId, standardId, useRUIData),
    {
      ...options,
      enabled: enabled !== undefined ? enabled : !!versionId,
    }
  );
}
